/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Options from './Options';
import UserResponse from './UserResponse';

/**
* The GetUserResponse model module.
* @module model/GetUserResponse
* @version 2020-12-7
*/
export default class GetUserResponse {
    /**
    * Constructs a new <code>GetUserResponse</code>.
    * ユーザー取得レスポンス
    * @alias module:model/GetUserResponse
    * @class
    * @param user {module:model/UserResponse} 
    * @param result {module:model/GetUserResponse.ResultEnum} 
    */

    constructor(user, result) {
        
        
        this['user'] = user;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>GetUserResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/GetUserResponse} obj Optional instance to populate.
    * @return {module:model/GetUserResponse} The populated <code>GetUserResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new GetUserResponse();
                        
            
            if (data.hasOwnProperty('user')) {
                obj['user'] = UserResponse.constructFromObject(data['user']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
            if (data.hasOwnProperty('options')) {
                obj['options'] = Options.constructFromObject(data['options']);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/UserResponse} user
    */
    'user' = undefined;
    /**
    * @member {module:model/GetUserResponse.ResultEnum} result
    */
    'result' = undefined;
    /**
    * @member {module:model/Options} options
    */
    'options' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
